export const draftQueuePermissions = {
  pageId: 67,
  name: 'Draft Queue',
  path: 'draft-queue',
} as const;
